module.exports = __webpack_public_path__ + "static/media/sao-tome-and-principe.622fe336.svg";